import request from '@/utils/request'

export function getContractProbationAlertOverview () {
  return request({
    url: '/addon/contractProbationAlert/overview',
    method: 'get'
  })
}
